import FieldNumeric from 'components/FieldNumeric'

export const CcvField = () => (
    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <FieldNumeric source="minCcv" label="Min ccv" />
        <FieldNumeric source="maxCcv" label="Max ccv (0 = Inf)" />
    </div>
)
